// @flow

import { observer } from "mobx-react";
import React from "react";
import Video from "app/models/Video";

import "./VideoAbout.scss";

type Props = {
    video: Video,
    editable: boolean,
    onReport: Function,
    onShare: Function
};

type State = {};

@observer
export default class VideoAbout extends React.Component<Props, State> {
    render() {
        const classes = ["VideoAbout"];

        return (
            <div className={classes.join(" ")}>
                <div className="VideoAbout__content">
                    {this.renderShare()}
                </div>
            </div>
        );
    }

    renderShare() {
        if (!this.props.video.isPublished) return null;

        return (
            <div>
                <button
                    type="button"
                    onClick={this.props.onShare}
                    className="VideoAbout__share"
                >
                    <i className="fa fa-share" /> Share
                </button>
                <a
                    href={`/download-comments?tlv=${this.props.video.uid}`}
                    className="VideoAbout__download"
                    title="Download Comments"
                >
                    <i className="fa fa-download" />
                </a>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/VideoAbout/VideoAbout.js